import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyDz4W9WDDPylM0Jh2Idg0O9-GMYMchOl-0",
    authDomain: "krene-d7a79.firebaseapp.com",
    projectId: "krene-d7a79",
    storageBucket: "krene-d7a79.firebasestorage.app",
    messagingSenderId: "79482932829",
    appId: "1:79482932829:web:5ff81d74977b80889547b4",
    measurementId: "G-WTEZXWHS2Z"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;